import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainFamilyComponent } from './main-family/main-family.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { UserInfoComponent } from './user-info/user-info.component';



@NgModule({
  declarations: [
    MainFamilyComponent,
    UserInfoComponent
  ],
  imports: [
    CommonModule,
    MatPaginatorModule
  ]
})
export class FamilyModule { }
